import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Routes, Route,  useNavigate, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import '../styles/App.scss';
import useUserSession from './useUserSession';
import { getToken } from './sessionManager';
import LoadingPage from './tools/LoadingPage';
import ChatBot from './ChatBot';

// Lazy loading des pages pour réduire le bundle initial
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const AjoutAnnonce = lazy(() => import('./pages/AjoutAnnonce'));
const ShowService = lazy(() => import('./pages/ShowService'));
const AjoutAnnonceKilo = lazy(() => import('./pages/AjoutAnnonceKilo'));
const AjoutAnnonceContainer = lazy(() => import('./pages/AjoutAnnonceContainer'));
const ShowPartage = lazy(() => import('./pages/ShowPartage'));
const AjoutAnnonceSuccess = lazy(() => import('./pages/AjoutAnnonceSuccess'));
const ShowAnnonce = lazy(() => import('./pages/ShowAnnonce'));
const ShowStatistique = lazy(() => import('./pages/ShowStatistique'));
const ShowPayment = lazy(() => import('./pages/ShowPayment'));
const ShowGoChat = lazy(() => import('./pages/ShowGoChat'));
const Chat = lazy(() => import('./pages/Chat'));
const ShowProfil = lazy(() => import('./pages/ShowProfil'));
const EditAnnonce = lazy(() => import('./pages/EditAnnonce'));

function App() {
    const { user, loading, setLoading, setNbnotif } = useUserSession();
    const navigate = useNavigate();
    const location = useLocation();

    //etat permattant d'afficher ou de masquer le footer
    const [isFooter, setIsFooter] = useState(true);

    const [data, setData] = useState({ containers: [], kilos: [] });
    const [dataUser, setDataUser] = useState({ containers: [], kilos: [] });
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [googleCon, setGoogleCon] = useState('');
    //const [loading, setLoading] = useState(true);
      //state permettant de masquer ou d'afficher certains elements du menu
    const [isShowAnnonce, setIsShowAnnonce]=useState(false)
    useEffect(() => {
        if (!loading && user && (location.pathname === '/showAnnonce' || location.pathname === '/showStatistique' || location.pathname === '/showPayment' || location.pathname === '/profil')) {
          setIsShowAnnonce(true); // On masque certains elements de la navigation
        }
        else{
          setIsShowAnnonce(false);
        }
    }, [loading, location, navigate]);

    //script de chargement de page
    useEffect(() => {
        setLoading(true)
        if (isLoaded) {
          setLoading(false)
        }
    }, [isLoaded,user])
    
    

    //effet de bord permattant d'afficher ou de masquer le footer
    const handleFooter = () => {
        if (location.pathname === '/chat') {
            setIsFooter(false); // Masquer le footer sur ces pages spécifiques
        } else {
            setIsFooter(true); // Afficher le footer sur les autres pages
        }
    };
    useEffect(() => {
        handleFooter(); // Appel conditionnel du footer en fonction de la route
    }, [location.pathname]); // Exécuter à chaque changement de route

    useEffect(() => {
        setGoogleCon(localStorage.getItem('email'));
    }, [setGoogleCon]);

    // useEffect(() => {
    //     console.log("Utilisateur connecté :", user);
    //     setLoading(false); // Marque le chargement comme terminé une fois que l'utilisateur est récupéré
    // }, [user]);
    //on recupere toutes les annonces
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/annonce/announces`, {
            method: 'POST'
        })
        .then(res => res.json())
        .then(
            (result) => {
                setIsLoaded(true);
                setData(result);
            },
            (error) => {
                setIsLoaded(true);
                setError(error);
            }
        );
    }, []);
    //on recupere toutes les annonces lier a l'utilisateur
    useEffect(() => {
        const token = getToken();
        if (token) {
            fetch(`${process.env.REACT_APP_API_URL}/api/annonce/getannouncementbyid`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Ajouter l'en-tête Authorization
                }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setDataUser(result);
                    //console.log(result)
                },
                (error) => {
                    //setIsLoaded(true);
                    setError(error);
                }
            );
        }
    }, [user, loading, navigate]);
    //on recupere le nombre de notifications non lues
    useEffect(() => {
        const token = getToken();
        if (token && user) {
            fetch(`${process.env.REACT_APP_API_URL}/api/notification/notread`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(res => res.json())
            .then((result) => {
                if (result.badges !== undefined) {
                    setNbnotif(result.badges);
                }
            })
            .catch(() => {});
        }
    }, [user]);

    //script permerttant d'etre au debut de page a chaque changement de route
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);




    // Affiche un spinner pendant le chargement initial
    if (loading) {
        return <LoadingPage error={error}/>;
    }

    return (
        <>
            <Navigation data={data} error={error} googleCon={googleCon} setGoogleCon={setGoogleCon} />
            <Suspense fallback={<LoadingPage error={null}/>}>
            <Routes>
                <Route path="/" element={<Home googleCon={googleCon} setGoogleCon={setGoogleCon} data={data} error={error} isLoaded={isLoaded} />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/service" element={<ShowService data={data} error={error} isLoaded={isLoaded} />} />
                <Route path="/service/:content/:id" element={<ShowPartage data={data} error={error} isLoaded={isLoaded} setIsLoaded={setIsLoaded} setLoading={setLoading} />} />
                <Route path="/ajoutAnnonce" element={<AjoutAnnonce />} />
                <Route path="/ajoutAnnonce/container" element={<AjoutAnnonceContainer />} />
                <Route path="/ajoutAnnonce/kilo" element={<AjoutAnnonceKilo/>} />
                <Route path="/ajoutAnnonce/success" element={<AjoutAnnonceSuccess/>} />
                <Route path="/showAnnonce" element={<ShowAnnonce  googleCon={googleCon} setGoogleCon={setGoogleCon} data={dataUser} error={error} isLoaded={isLoaded}/>} />
                <Route path="/showGoChat" element={<ShowGoChat/>} />
                <Route path="/chat" element={<Chat/>} />
                <Route path="/profil" element={<ShowProfil googleCon={googleCon} setGoogleCon={setGoogleCon}/>} />
                <Route path="/showStatistique" element={<ShowStatistique  googleCon={googleCon} setGoogleCon={setGoogleCon} data={data} dataUser={dataUser} error={error} isLoaded={isLoaded}/>} />
                <Route path="/showPayment" element={<ShowPayment  googleCon={googleCon} setGoogleCon={setGoogleCon} data={data} error={error} isLoaded={isLoaded}/>} />
                <Route path="/editAnnonce/:type/:id" element={<EditAnnonce />} />
            </Routes>
            </Suspense>
            {(isFooter && !isShowAnnonce) && <Footer data={data} error={error} />}
            {location.pathname === '/' && <ChatBot />}
        </>
    );
}

export default App;
